import { MainPage } from './mainpage'

export * from './mainpage'

export default MainPage